import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import Layout from '@/components/Layout';
import AdminDashboard from '@/components/AdminDashboard';
import ClientDashboard from '@/components/ClientDashboard';
import RoleBasedNavigation from '@/components/RoleBasedNavigation';
import DashboardSkeleton from '@/components/DashboardSkeleton';
import ClientSelectionModal from '@/components/ClientSelectionModal';

const Dashboard = () => {
  const { user, pendingSelection } = useAuth();

  // Login multi-conta: ainda não há sessão. Mostra o esqueleto borrado + modal de escolha
  // ANTES do RoleBasedNavigation (que redirecionaria por falta de usuário).
  if (pendingSelection) {
    return (
      <>
        <DashboardSkeleton className="blur-sm pointer-events-none select-none" />
        <ClientSelectionModal />
      </>
    );
  }

  return (
    <RoleBasedNavigation>
      <Layout>
        {['admin', 'analista'].includes(user?.role || '') ? <AdminDashboard /> : <ClientDashboard />}
      </Layout>
    </RoleBasedNavigation>
  );
};

export default Dashboard;
